module.exports = __webpack_public_path__ + "assets/img/icon-badge-5facdf30.png";